import { render, staticRenderFns } from "./rankingCard.vue?vue&type=template&id=71e4ded4&scoped=true"
import script from "./rankingCard.vue?vue&type=script&lang=js"
export * from "./rankingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4ded4",
  null
  
)

export default component.exports